
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { RequestUpdateSettingOnboarding } from '../../../shared/nestjs/gd-only/dto/setting-onboarding.dto';
import { SettingOnboardingApi } from '../../../shared/nestjs/gd-only/services/setting-onboarding.api';

@Injectable()
export class SettingOnboardingBloc {
  private subscriptions: Array<Subscription> = [];
  constructor(
    public settingOnboardingApi: SettingOnboardingApi,
  ) {

  }

  // dispose() {
  //   this.subscriptions.forEach((sub) => sub.unsubscribe());
  // }

  getOnBoarding() {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.settingOnboardingApi.getOnBoarding()
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

  postOnBoarding(payload: RequestUpdateSettingOnboarding) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.settingOnboardingApi.postOnBoarding(payload)
          .map(res => res.data)
          .subscribe(response => {
            resolve(response);
          }, error => {
            reject(error);
          })
      )
    })
  }

}




// WEBPACK FOOTER //
// ./src/bloc/settings/employee-setup/setting-onboarding.bloc.ts